/**
 * @generated SignedSource<<914684de27ca6bad819b1872f6601ea9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClinicianAppointmentForm_query$data = {
  readonly services: {
    readonly nodes: ReadonlyArray<{
      readonly duration: {
        readonly minutes: number | null;
      };
      readonly name: string;
      readonly rowId: any;
    }>;
  } | null;
  readonly " $fragmentType": "ClinicianAppointmentForm_query";
};
export type ClinicianAppointmentForm_query$key = {
  readonly " $data"?: ClinicianAppointmentForm_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClinicianAppointmentForm_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClinicianAppointmentForm_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "condition",
          "value": {
            "isActive": true
          }
        }
      ],
      "concreteType": "ServicesConnection",
      "kind": "LinkedField",
      "name": "services",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Service",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rowId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Interval",
              "kind": "LinkedField",
              "name": "duration",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "minutes",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "services(condition:{\"isActive\":true})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "324628537fa9f61d7c29cfca34c64d17";

export default node;
